import React, { useState } from 'react'
import axios from 'axios'
import { Button, Col, Space, Form } from 'antd'
import {
  getHeaders,
  adminUsersUrl,
  successNotification,
  errorNotification
} from '../../config'
import BasicInput from '../../components/Forms/BasicInput'
import PropTypes from 'prop-types'

const Update = props => {
  const [customer, setCustomer] = useState({
    email: props.customer.email,
    firstName: props.customer.firstName,
    lastName: props.customer.lastName,
    phoneNumber: props.customer.phoneNumber
  })

  const [serverErrors, setServerErrors] = useState({})
  const [loading, setLoading] = useState(false)

  const handleInputChange = stateName => event => {
    setCustomer({ ...customer, [stateName]: event.target.value })
  }

  const handleSubmit = event => {
    event.preventDefault()
    setLoading(true)
    axios
      .put(adminUsersUrl + '/' + props.customer.id, customer, {
        headers: getHeaders()
      })
      .then(() => {
        setLoading(false)
        // eslint-disable-next-line react/prop-types
        props.handleCancel()
        successNotification('Customer Updated')
      })
      .catch(err => {
        setLoading(false)
        if (err.response) {
          setServerErrors(err.response.data)
        }
        errorNotification('Error adding customer, retry.')
      })
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <Form className="p-2rem" layout="vertical">
            <div className="row">
              <div className="col-md-5">
                <BasicInput
                  label="First Name"
                  value={customer.firstName}
                  name={'first name'}
                  placeholder="first name"
                  handleChange={handleInputChange('firstName')}
                  required={false}
                />
                {serverErrors.firstName &&
                  serverErrors.firstName.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5 offset-md-2 offset-sm-0 ">
                <BasicInput
                  label="Last Name"
                  value={customer.lastName}
                  name={'last name'}
                  placeholder="last name"
                  handleChange={handleInputChange('lastName')}
                  required={false}
                />

                {serverErrors.lastName &&
                  serverErrors.lastName.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5">
                <BasicInput
                  label="Email"
                  value={customer.email}
                  name={'email'}
                  placeholder="email"
                  handleChange={handleInputChange('email')}
                  required={false}
                />
                {serverErrors.email &&
                  serverErrors.email.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              <div className="col-md-5 offset-md-2 offset-sm-0">
                <BasicInput
                  label="Phone Number"
                  value={customer.phoneNumber}
                  name={'phone'}
                  placeholder="phone number"
                  handleChange={handleInputChange('phoneNumber')}
                  required={true}
                />
                {serverErrors.phoneNumber &&
                  serverErrors.phoneNumber.map((err, i) => (
                    <div className="text-danger" key={i}>
                      {err}
                    </div>
                  ))}
              </div>

              {serverErrors.nonFieldErrors &&
                serverErrors.nonFieldErrors.map((err, i) => (
                  <div className="text-danger" key={i}>
                    {err}
                  </div>
                ))}

              <Col md={24}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    marginBottom: '20px'
                  }}
                >
                  <Space>
                    {/* eslint-disable-next-line react/prop-types */}
                    <Button onClick={() => props.history.goBack()}>
                      Go Back
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSubmit}
                      loading={loading}
                    >
                      Submit
                    </Button>
                  </Space>
                </div>
              </Col>
            </div>
          </Form>
        </div>
      </div>
    </div>
  )
}

Update.propTypes = {
  customer: PropTypes.object,
  handleCancel: PropTypes.object
}

export default Update
